'use strict';

var React = require('react');

var SvgFileMinor = function SvgFileMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-11a1 1 0 0 0-.293-.707l-3-3a1 1 0 0 0-.707-.293h-7Zm1 14v-12h5v2a1 1 0 0 0 1 1h2v9h-8Z"
  }));
};

exports.SvgFileMinor = SvgFileMinor;
